<template>
  <v-container class="container-max-width">
    <v-row class="page-wrapper">
      <v-col offset="2" cols="8">
        <v-row>
          <v-col cols="12" class="align-center">
            <div class="text-center">
              <svg width="130px" height="30px" viewBox="0 0 130 30">
                <circle cx="10" cy="10" r="9" class="filled"/>
                <line x1="19" y1="10" x2="31" y2="10" class="line"/>
                <circle cx="40" cy="10" r="9" class="filled"/>
                <line x1="49" y1="10" x2="61" y2="10" class="line"/>
                <circle cx="70" cy="10" r="9" class="not-filled"/>
                <line x1="79" y1="10" x2="91" y2="10" class="line"/>
                <circle cx="100" cy="10" r="9" class="not-filled"/>
              </svg>
            </div>
          </v-col>
        </v-row>
        <v-row class="heading-text-wrapper">
          <v-col class="text-no-wrap" cols="12">
            <p class="text-h1 ml-5 text-center">What type of store are you?</p>
          </v-col>
        </v-row>
        <v-row class="buttons-wrapper text-center">
          <v-col>
            <ParentStoreButton @click.native="setShopType('source')"/>
          </v-col>
          <v-col>
            <ChildStoreButton @click.native="setShopType('destination')"/>
          </v-col>
        </v-row>
        <v-row class="read-guide">
          <v-col cols="12">
            <p class="text-body-1 text-center">Not sure? Read our guide here.</p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ParentStoreButton from "@/views/registration/components/ParentStoreButton";
import ChildStoreButton from "@/views/registration/components/ChildStoreButton";
import {ASSIGN_SHOP_TYPE} from "@/store/actions.type";

export default {
  name: "SelectStoreType",
  components: { ChildStoreButton, ParentStoreButton },
  methods : {
    setShopType(type) {
      this.$store.dispatch(`shop/${ASSIGN_SHOP_TYPE}`, { type: type })
      this.$router.push({name: 'registration.woocommerce.verify-store-url'})
    }
  }
}
</script>

<style scoped>
.page-wrapper{
  margin-top: 3%;
}
.heading-text-wrapper{
  margin-top: 7%;
}
.buttons-wrapper{
  margin-top: 6%;
  align-content: center;
}
.filled{
  fill: #fcb058;
  stroke-width: 1;
  stroke: #f57c00;
}
.not-filled{
  fill: none;
  stroke-width: 1;
  stroke: #f57c00;
}
.line{
  stroke-width: 2;
  stroke:#f57c00
}
.read-guide{
  margin-top: 6%;
}
.container-max-width{
  max-width: 1200px;
  min-width: 768px !important;
}
</style>